import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
    Aangifte,
    BokkzAlgDataService,
    BokkzIbDataService,
    IncomeTaxEntity,
    JaarrekeningBalans, Onderneming, Ondernemingsvorm
} from '@snelstart-ventures/fiscaal/domain-logic';
import { BehaviorSubject, filter, Subscription } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Event, NavigationEnd, Router } from '@angular/router';
import { ToastService } from '@snelstart/ui-toast';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SpecGebouwenEigenComponent } from '../spec-gebouwen-eigen/spec-gebouwen-eigen.component';
import { SpecMachinesInstallatiesComponent } from '../spec-machines-installaties/spec-machines-installaties.component';
import {
    SpecOverigMaterieleVasteActivaComponent
} from '../spec-overig-materiele-vaste-activa/spec-overig-materiele-vaste-activa.component';
import { SpecOmzetbelastingActivaComponent } from '../spec-omzetbelasting-activa/spec-omzetbelasting-activa.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'snelstart-venture-fiscaal-feature-balans-activa',
    templateUrl: './balans-activa.component.html',
    styleUrls: ['./balans-activa.component.scss'],
    imports: [
        SharedUiFormControlsModule,
        SharedUiDetailsModule,
        SpecGebouwenEigenComponent,
        SpecMachinesInstallatiesComponent,
        SpecOverigMaterieleVasteActivaComponent,
        SpecOmzetbelastingActivaComponent,
        CommonModule
    ]
})
export class BalansActivaComponent implements OnInit, OnDestroy {
    private subscriptions = new Subscription()
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    public clientId!: string;
    @Input() public id!: string;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    public partnerBoolean: boolean = false;
    @Input() partner = new BehaviorSubject<boolean>(false);
    private partnerAangifte = {} as Aangifte;
    private heeftSamenwerkingsverbandSubscription: Subscription | undefined;

    public labelBalansOpening = '';
    public labelBalansSlot = '';

    public showSpinner = true;

    public immaterieleVasteActivaGoodwllFg = {} as FormGroup;
    public immaterieleVasteActivaOverigFg = {} as FormGroup;
    public materieleVasteActivaGebouwenEigenFg = {} as FormGroup;
    public materieleVasteActivaMachinesFg = {} as FormGroup;
    public materieleVasteActivaOverigFg = {} as FormGroup;
    public financieleVasteActivaFg = {} as FormGroup;
    public vlottendeActivaVoorraadFg = {} as FormGroup;
    public vlottendeActivaVoorraadOhwFg = {} as FormGroup;
    public vlottendeActivaVorderingenDebiteurenFg = {} as FormGroup;
    public vlottendeActivaVorderingenOmzetbelastingFg = {} as FormGroup;
    public vlottendeActivaVorderingenOverigFg = {} as FormGroup;
    public effectenFg = {} as FormGroup;
    public liquideMiddelenFg = {} as FormGroup;
    public totalFg = {} as FormGroup;
    public heeftSamenwerkingsverband: boolean = false;

    public dialogVisible = false;

    public showDialog() {
        this.dialogVisible = true;
    }

    constructor(
        private fb: FormBuilder,
        private router: Router,
        public dataService: BokkzIbDataService,
        public toastService: ToastService,
        private dataAlgService: BokkzAlgDataService) {
        this.immaterieleVasteActivaGoodwllFg = this.fb.group<JaarrekeningBalans>({
            omschrijving: 'goodwill',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            aanschafWaarde: null as unknown as number,
            restWaarde: 0,
            bodemwaarde: 0,
            nominaleWaarde: 0
        });
        this.immaterieleVasteActivaOverigFg = this.fb.group<JaarrekeningBalans>({
            omschrijving: 'immaterieleVasteActiva',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            aanschafWaarde: null as unknown as number,
            restWaarde: 0,
            bodemwaarde: 0,
            nominaleWaarde: 0
        });
        this.materieleVasteActivaGebouwenEigenFg = this.fb.group<JaarrekeningBalans>({
            omschrijving: 'bedrijfsGebouwen',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            aanschafWaarde: null as unknown as number,
            restWaarde: null as unknown as number,
            nominaleWaarde: null as unknown as number,
            bodemwaarde: null as unknown as number,
            gebruikBinnenEigenOnderneming: true
        });
        this.materieleVasteActivaMachinesFg = this.fb.group<JaarrekeningBalans>({
            omschrijving: 'machinesEnInstallaties',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            aanschafWaarde: null as unknown as number,
            restWaarde: null as unknown as number,
            bodemwaarde: 0
        });
        this.materieleVasteActivaOverigFg = this.fb.group<JaarrekeningBalans>({
            omschrijving: 'andereVasteActiva',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            aanschafWaarde: null as unknown as number,
            restWaarde: null as unknown as number,
            bodemwaarde: 0
        });
        this.financieleVasteActivaFg = this.fb.group<JaarrekeningBalans>({
            omschrijving: 'financieleVasteActiva',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            nominaleWaarde: null as unknown as number
        });
        this.vlottendeActivaVoorraadFg = this.fb.group<JaarrekeningBalans>({
            omschrijving: 'voorraad',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            nominaleWaarde: null as unknown as number
        });
        this.vlottendeActivaVoorraadOhwFg = this.fb.group<JaarrekeningBalans>({
            omschrijving: 'onderhandenWerk',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            nominaleWaarde: null as unknown as number
        });
        this.vlottendeActivaVorderingenDebiteurenFg = this.fb.group<JaarrekeningBalans>({
            omschrijving: 'debiteuren',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            nominaleWaarde: null as unknown as number
        });
        this.vlottendeActivaVorderingenOmzetbelastingFg = this.fb.group<JaarrekeningBalans>({
            omschrijving: 'omzetbelastingVordering',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            nominaleWaarde: null as unknown as number,
            omzetbelastingDitBoekjaar: null as unknown as number,
            omzetbelastingVorigBoekjaar: null as unknown as number,
            omzetbelastingOudereBoekjaren: null as unknown as number
        });
        this.vlottendeActivaVorderingenOverigFg = this.fb.group<JaarrekeningBalans>({
            omschrijving: 'overigeVorderingen',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            nominaleWaarde: null as unknown as number
        });
        this.effectenFg = this.fb.group<JaarrekeningBalans>({
            omschrijving: 'effecten',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            nominaleWaarde: null as unknown as number
        });
        this.liquideMiddelenFg = this.fb.group<JaarrekeningBalans>({
            omschrijving: 'liquideMiddelen',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            nominaleWaarde: null as unknown as number
        });
        this.totalFg = this.fb.group({
            totaalOpening: null as unknown as number,
            totaalSlot: null as unknown as number
        });
    }

    getTotaalActivaOpening(partner: boolean): number {
        const onderneming = !partner ? this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming?.ondernemingen[0] : this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen[0];
        if (onderneming) {
            const goodWill = onderneming?.immaterieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'goodwill')?.waardeOpening || 0;
            const immaterieleVasteActiva = onderneming?.immaterieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'immaterieleVasteActiva')?.waardeOpening || 0;
            const bedrijfsGebouwen = onderneming?.materieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'bedrijfsGebouwen')?.waardeOpening || 0;
            const machinesEnInstallaties = onderneming?.materieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'machinesEnInstallaties')?.waardeOpening || 0;
            const andereVasteActiva = onderneming?.materieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'andereVasteActiva')?.waardeOpening || 0;
            const financieleVasteActiva = onderneming?.financieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'financieleVasteActiva')?.waardeOpening || 0;
            const onderhandenWerk = onderneming?.vlottendeActivaVoorraad?.filter(item => item !== null).find(item => item.omschrijving === 'onderhandenWerk')?.waardeOpening || 0;
            const voorraad = onderneming?.vlottendeActivaVoorraad?.filter(item => item !== null).find(item => item.omschrijving === 'voorraad')?.waardeOpening || 0;
            const debiteuren = onderneming?.vlottendeActivaVorderingen?.filter(item => item !== null).find(item => item.omschrijving === 'debiteuren')?.waardeOpening || 0;
            const omzetbelastingVordering = onderneming?.vlottendeActivaVorderingen?.filter(item => item !== null).find(item => item.omschrijving === 'omzetbelastingVordering')?.waardeOpening || 0;
            const overigeVorderingen = onderneming?.vlottendeActivaVorderingen?.filter(item => item !== null).find(item => item.omschrijving === 'overigeVorderingen')?.waardeOpening || 0;
            const effecten = onderneming?.effecten?.filter(item => item !== null).find(item => item.omschrijving === 'effecten')?.waardeOpening || 0;
            const liquideMiddelen = onderneming?.liquideMiddelen?.filter(item => item !== null).find(item => item.omschrijving === 'liquideMiddelen')?.waardeOpening || 0;

            return goodWill + immaterieleVasteActiva + bedrijfsGebouwen + machinesEnInstallaties + andereVasteActiva + onderhandenWerk + voorraad +
                financieleVasteActiva + debiteuren + omzetbelastingVordering + overigeVorderingen +
                effecten + liquideMiddelen;
        }
        return 0;
    }

    getTotaalActivaSlot(partner: boolean): number {
        const onderneming = !partner ? this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming?.ondernemingen[0] : this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen[0];
        if (onderneming) {
            const goodWill = onderneming?.immaterieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'goodwill')?.waardeSlot || 0;
            const immaterieleVasteActiva = onderneming?.immaterieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'immaterieleVasteActiva')?.waardeSlot || 0;
            const bedrijfsGebouwen = onderneming?.materieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'bedrijfsGebouwen')?.waardeSlot || 0;
            const machinesEnInstallaties = onderneming?.materieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'machinesEnInstallaties')?.waardeSlot || 0;
            const andereVasteActiva = onderneming?.materieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'andereVasteActiva')?.waardeSlot || 0;
            const financieleVasteActiva = onderneming?.financieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'financieleVasteActiva')?.waardeSlot || 0;
            const onderhandenWerk = onderneming?.vlottendeActivaVoorraad?.filter(item => item !== null).find(item => item.omschrijving === 'onderhandenWerk')?.waardeSlot || 0;
            const voorraad = onderneming?.vlottendeActivaVoorraad?.filter(item => item !== null).find(item => item.omschrijving === 'voorraad')?.waardeSlot || 0;
            const debiteuren = onderneming?.vlottendeActivaVorderingen?.filter(item => item !== null).find(item => item.omschrijving === 'debiteuren')?.waardeSlot || 0;
            const omzetbelastingVordering = onderneming?.vlottendeActivaVorderingen?.filter(item => item !== null).find(item => item.omschrijving === 'omzetbelastingVordering')?.waardeSlot || 0;
            const overigeVorderingen = onderneming?.vlottendeActivaVorderingen?.filter(item => item !== null).find(item => item.omschrijving === 'overigeVorderingen')?.waardeSlot || 0;
            const effecten = onderneming?.effecten?.filter(item => item !== null).find(item => item.omschrijving === 'effecten')?.waardeSlot || 0;
            const liquideMiddelen = onderneming?.liquideMiddelen?.filter(item => item !== null).find(item => item.omschrijving === 'liquideMiddelen')?.waardeSlot || 0;

            return goodWill + immaterieleVasteActiva + bedrijfsGebouwen + machinesEnInstallaties + andereVasteActiva + onderhandenWerk + voorraad +
                financieleVasteActiva + debiteuren + omzetbelastingVordering + overigeVorderingen +
                effecten + liquideMiddelen;
        }
        return 0;
    }

    private resetFormGroups() {
        this.immaterieleVasteActivaGoodwllFg.setValue({
            omschrijving: 'goodwill',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            aanschafWaarde: null as unknown as number,
            restWaarde: 0,
            bodemwaarde: 0,
            nominaleWaarde: 0
        }, { emitEvent: false });
        this.immaterieleVasteActivaOverigFg.setValue({
            omschrijving: 'immaterieleVasteActiva',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            aanschafWaarde: null as unknown as number,
            restWaarde: 0,
            bodemwaarde: 0,
            nominaleWaarde: 0
        }, { emitEvent: false });
        this.materieleVasteActivaGebouwenEigenFg.setValue({
            omschrijving: 'bedrijfsGebouwen',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            aanschafWaarde: null as unknown as number,
            restWaarde: null as unknown as number,
            nominaleWaarde: null as unknown as number,
            bodemwaarde: null as unknown as number,
            gebruikBinnenEigenOnderneming: true
        }, { emitEvent: false });
        this.materieleVasteActivaMachinesFg.setValue({
            omschrijving: 'machinesEnInstallaties',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            aanschafWaarde: null as unknown as number,
            restWaarde: null as unknown as number,
            bodemwaarde: 0
        }, { emitEvent: false });
        this.materieleVasteActivaOverigFg.setValue({
            omschrijving: 'andereVasteActiva',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            aanschafWaarde: null as unknown as number,
            restWaarde: null as unknown as number,
            bodemwaarde: 0
        }, { emitEvent: false });
        this.financieleVasteActivaFg.setValue({
            omschrijving: 'financieleVasteActiva',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            nominaleWaarde: null as unknown as number
        }, { emitEvent: false });
        this.vlottendeActivaVoorraadFg.setValue({
            omschrijving: 'voorraad',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            nominaleWaarde: 0
        }, { emitEvent: false });
        this.vlottendeActivaVoorraadOhwFg.setValue({
            omschrijving: 'onderhandenWerk',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            nominaleWaarde: 0
        }, { emitEvent: false });
        this.vlottendeActivaVorderingenDebiteurenFg.setValue({
            omschrijving: 'debiteuren',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            nominaleWaarde: null as unknown as number
        }, { emitEvent: false });
        this.vlottendeActivaVorderingenOmzetbelastingFg.setValue({
            omschrijving: 'omzetbelastingVordering',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            nominaleWaarde: 0,
            omzetbelastingDitBoekjaar: null as unknown as number,
            omzetbelastingVorigBoekjaar: null as unknown as number,
            omzetbelastingOudereBoekjaren: null as unknown as number
        }, { emitEvent: false });
        this.vlottendeActivaVorderingenOverigFg.setValue({
            omschrijving: 'overigeVorderingen',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            nominaleWaarde: null as unknown as number
        }, { emitEvent: false });
        this.effectenFg.setValue({
            omschrijving: 'effecten',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            nominaleWaarde: 0
        }, { emitEvent: false });
        this.liquideMiddelenFg.setValue({
            omschrijving: 'liquideMiddelen',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            nominaleWaarde: 0
        }, { emitEvent: false });
        this.totalFg.setValue({
            totaalOpening: null as unknown as number,
            totaalSlot: 0
        }, { emitEvent: false });
    }

    public ngOnInit(): void {
        // Partner subscription APART, niet nested
        this.subscriptions = new Subscription();

        this.subscriptions.add(
            this.partner.subscribe((partner) => {
                this.partnerBoolean = partner;
                this.resetFormGroups();
                this.updateForm();
                this.updateHeeftSamenwerkingsverband();
            })
        );

        this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                this.partnerAangifte = incomeTaxEntity.aangifte.partnerAangifte ?? {} as Aangifte;
                this.resetFormGroups();
                this.updateForm();
                this.updateHeeftSamenwerkingsverband();
            }
        });

        this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) => {
            if (client.sstRelationId) {
                this.clientId = client.sstRelationId;
            }
        });

        this.routerSubscription = this.router.events
            .pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.handleUrlChange(event.urlAfterRedirects);
            });
    }

    private updateForm(): void {
        const onderneming = this.partnerBoolean
            ? this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen?.[0]
            : this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming?.ondernemingen?.[0];

        if (!onderneming) return;

        // immateriele vaste activa
        const goodWill = onderneming.immaterieleVasteActiva?.find(item => item.omschrijving === 'goodwill') ?? this.createJaarrekeningBalans('goodwill');
        const immaterieleVasteActiva = onderneming.immaterieleVasteActiva?.find(item => item.omschrijving === 'immaterieleVasteActiva') ?? this.createJaarrekeningBalans('immaterieleVasteActiva');
        this.immaterieleVasteActivaGoodwllFg.patchValue(goodWill, { emitEvent: false });
        this.immaterieleVasteActivaOverigFg.patchValue(immaterieleVasteActiva, { emitEvent: false });

        // materiele vaste activa
        const bedrijfsGebouwen = onderneming.materieleVasteActiva?.find(item => item.omschrijving === 'bedrijfsGebouwen') ?? this.createJaarrekeningBalans('bedrijfsGebouwen');
        const machinesEnInstallaties = onderneming.materieleVasteActiva?.find(item => item.omschrijving === 'machinesEnInstallaties') ?? this.createJaarrekeningBalans('machinesEnInstallaties');
        const andereVasteActiva = onderneming.materieleVasteActiva?.find(item => item.omschrijving === 'andereVasteActiva') ?? this.createJaarrekeningBalans('andereVasteActiva');
        this.materieleVasteActivaGebouwenEigenFg.patchValue(bedrijfsGebouwen, { emitEvent: false });
        this.materieleVasteActivaMachinesFg.patchValue(machinesEnInstallaties, { emitEvent: false });
        this.materieleVasteActivaOverigFg.patchValue(andereVasteActiva, { emitEvent: false });

        // financiele vaste activa
        const financieleVasteActiva = onderneming.financieleVasteActiva?.find(item => item.omschrijving === 'financieleVasteActiva') ?? this.createJaarrekeningBalans('financieleVasteActiva');
        this.financieleVasteActivaFg.patchValue(financieleVasteActiva, { emitEvent: false });

        // vlottende activa - voorraad
        const voorraad = onderneming.vlottendeActivaVoorraad?.find(item => item.omschrijving === 'voorraad') ?? this.createJaarrekeningBalans('voorraad');
        const onderhandenWerk = onderneming.vlottendeActivaVoorraad?.find(item => item.omschrijving === 'onderhandenWerk') ?? this.createJaarrekeningBalans('onderhandenWerk');
        this.vlottendeActivaVoorraadFg.patchValue(voorraad, { emitEvent: false });
        this.vlottendeActivaVoorraadOhwFg.patchValue(onderhandenWerk, { emitEvent: false });

        // vlottende activa - vorderingen
        const debiteuren = onderneming.vlottendeActivaVorderingen?.find(item => item.omschrijving === 'debiteuren') ?? this.createJaarrekeningBalans('debiteuren');
        const omzetbelastingVordering = onderneming.vlottendeActivaVorderingen?.find(item => item.omschrijving === 'omzetbelastingVordering') ?? this.createJaarrekeningBalans('omzetbelastingVordering');
        const overigeVorderingen = onderneming.vlottendeActivaVorderingen?.find(item => item.omschrijving === 'overigeVorderingen') ?? this.createJaarrekeningBalans('overigeVorderingen');
        this.vlottendeActivaVorderingenDebiteurenFg.patchValue(debiteuren, { emitEvent: false });
        this.vlottendeActivaVorderingenOmzetbelastingFg.patchValue(omzetbelastingVordering, { emitEvent: false });
        this.vlottendeActivaVorderingenOverigFg.patchValue(overigeVorderingen, { emitEvent: false });

        // liquide middelen
        const effecten = onderneming.effecten?.find(item => item.omschrijving === 'effecten') ?? this.createJaarrekeningBalans('effecten');
        const liquideMiddelen = onderneming.liquideMiddelen?.find(item => item.omschrijving === 'liquideMiddelen') ?? this.createJaarrekeningBalans('liquideMiddelen');
        this.effectenFg.patchValue(effecten, { emitEvent: false });
        this.liquideMiddelenFg.patchValue(liquideMiddelen, { emitEvent: false });

        // totalen
        this.totalFg.patchValue({
            totaalSlot: this.getTotaalActivaSlot(this.partnerBoolean),
            totaalOpening: this.getTotaalActivaOpening(this.partnerBoolean)
        });

        // labels
        let begindatum = new Date;
        if (onderneming.startOnderneming != null) {
            begindatum = onderneming.startOnderneming
        } else {
            begindatum = new Date(this.incomeTaxEntity.aangifte!.aangifteJaar, 0, 1);
        }
        let slotdatum = new Date;
        if (onderneming.datumStaking != null) {
            slotdatum = onderneming.datumStaking
        } else {
            slotdatum = new Date(this.incomeTaxEntity.aangifte!.aangifteJaar, 11, 31);
        }
        onderneming.boekjaar?.begindatum;
        this.labelBalansOpening = begindatum != null
            ? `Balans ${new Date(begindatum).toLocaleDateString('nl-NL', { day: '2-digit', month: '2-digit', year: 'numeric' })}`
            : 'Openingsbalans';
        this.labelBalansSlot = slotdatum != null
            ? `Balans ${new Date(slotdatum).toLocaleDateString('nl-NL', { day: '2-digit', month: '2-digit', year: 'numeric' })}`
            : 'Slotbalans';
    }

    // public ngOnInit(): void {
    //     this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
    //         this.incomeTaxEntity = incomeTaxEntity;
    //         if (incomeTaxEntity.aangifte) {
    //             this.partnerAangifte = incomeTaxEntity.aangifte.partnerAangifte ? incomeTaxEntity.aangifte.partnerAangifte : {} as Aangifte;
    //             this.partner.subscribe((partner) => {
    //                 this.partnerBoolean = partner;
    //                 this.resetFormGroups();
    //                 const onderneming = !partner ? incomeTaxEntity.aangifte?.box1?.winstUitOnderneming?.ondernemingen[0] : this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen[0];
    //                 if (onderneming) {
    //                     //immateriele vaste activa
    //                     const goodWill = onderneming?.immaterieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'goodwill') || this.createJaarrekeningBalans('goodwill');
    //                     const immaterieleVasteActiva = onderneming?.immaterieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'immaterieleVasteActiva') || this.createJaarrekeningBalans('immaterieleVasteActiva');
    //                     this.immaterieleVasteActivaGoodwllFg.patchValue(goodWill, { emitEvent: false });
    //                     this.immaterieleVasteActivaOverigFg.patchValue(immaterieleVasteActiva, { emitEvent: false });
    //
    //                     //materiele vaste activa
    //                     const bedrijfsGebouwen = onderneming?.materieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'bedrijfsGebouwen') || this.createJaarrekeningBalans('bedrijfsGebouwen');
    //                     const machinesEnInstallaties = onderneming?.materieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'machinesEnInstallaties') || this.createJaarrekeningBalans('machinesEnInstallaties');
    //                     const andereVasteActiva = onderneming?.materieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'andereVasteActiva') || this.createJaarrekeningBalans('andereVasteActiva');
    //                     this.materieleVasteActivaGebouwenEigenFg.patchValue(bedrijfsGebouwen, { emitEvent: false });
    //                     this.materieleVasteActivaMachinesFg.patchValue(machinesEnInstallaties, { emitEvent: false });
    //                     this.materieleVasteActivaOverigFg.patchValue(andereVasteActiva, { emitEvent: false });
    //
    //                     //financiele vaste activa
    //                     const financieleVasteActiva = onderneming?.financieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'financieleVasteActiva') || this.createJaarrekeningBalans('financieleVasteActiva');
    //                     this.financieleVasteActivaFg.patchValue(financieleVasteActiva, { emitEvent: false });
    //
    //                     // //vlottende activa - voorraad
    //                     const voorraad = onderneming?.vlottendeActivaVoorraad?.filter(item => item !== null).find(item => item.omschrijving === 'voorraad') || this.createJaarrekeningBalans('voorraad');
    //                     const onderhandenWerk = onderneming?.vlottendeActivaVoorraad?.filter(item => item !== null).find(item => item.omschrijving === 'onderhandenWerk') || this.createJaarrekeningBalans('onderhandenWerk');
    //                     this.vlottendeActivaVoorraadFg.patchValue(voorraad, { emitEvent: false });
    //                     this.vlottendeActivaVoorraadOhwFg.patchValue(onderhandenWerk, { emitEvent: false });
    //
    //                     //vlottende activa - vorderingen
    //                     const debiteuren = onderneming?.vlottendeActivaVorderingen?.filter(item => item !== null).find(item => item.omschrijving === 'debiteuren') || this.createJaarrekeningBalans('debiteuren');
    //                     const omzetbelastingVordering = onderneming?.vlottendeActivaVorderingen?.filter(item => item !== null).find(item => item.omschrijving === 'omzetbelastingVordering') || this.createJaarrekeningBalans('omzetbelastingVordering');
    //                     const overigeVorderingen = onderneming?.vlottendeActivaVorderingen?.filter(item => item !== null).find(item => item.omschrijving === 'overigeVorderingen') || this.createJaarrekeningBalans('overigeVorderingen');
    //                     this.vlottendeActivaVorderingenDebiteurenFg.patchValue(debiteuren, { emitEvent: false });
    //                     this.vlottendeActivaVorderingenOmzetbelastingFg.patchValue(omzetbelastingVordering, { emitEvent: false });
    //                     this.vlottendeActivaVorderingenOverigFg.patchValue(overigeVorderingen, { emitEvent: false });
    //
    //                     //liquide middelen
    //                     const effecten = onderneming?.effecten?.filter(item => item !== null).find(item => item.omschrijving === 'effecten') || this.createJaarrekeningBalans('effecten');
    //                     const liquideMiddelen = onderneming?.liquideMiddelen?.filter(item => item !== null).find(item => item.omschrijving === 'liquideMiddelen') || this.createJaarrekeningBalans('liquideMiddelen');
    //                     this.effectenFg.patchValue(effecten, { emitEvent: false });
    //                     this.liquideMiddelenFg.patchValue(liquideMiddelen, { emitEvent: false });
    //
    //                     const totaalActivaSlot = this.getTotaalActivaSlot(partner);
    //                     this.totalFg.patchValue({ totaalSlot: totaalActivaSlot });
    //                     const totaalActivaOpening = this.getTotaalActivaOpening(partner);
    //                     this.totalFg.patchValue({ totaalOpening: totaalActivaOpening });
    //
    //                     const begindatum = onderneming.boekjaar.begindatum;
    //                     this.labelBalansOpening = begindatum != null ? `Balans ${new Date(begindatum).toLocaleDateString('nl-NL', {
    //                         day: '2-digit',
    //                         month: '2-digit',
    //                         year: 'numeric'
    //                     })}` : 'Openingsbalans';
    //                     const slotdatum = onderneming.boekjaar.einddatum;
    //                     this.labelBalansSlot = slotdatum != null ? `Balans ${new Date(slotdatum).toLocaleDateString('nl-NL', {
    //                         day: '2-digit',
    //                         month: '2-digit',
    //                         year: 'numeric'
    //                     })}` : 'Openingsbalans';
    //                 }
    //                 this.updateHeeftSamenwerkingsverband();
    //             });
    //
    //         }
    //     });
    //     this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) => {
    //         if (client.sstRelationId) {
    //             this.clientId = client.sstRelationId;
    //         }
    //     });
    //     this.routerSubscription = this.router.events.pipe(filter(
    //         (event: Event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
    //         this.handleUrlChange(event.urlAfterRedirects);
    //     });
    // }

    private updateHeeftSamenwerkingsverband(): void {
        const ondernemingen = this.partnerBoolean
            ? this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen
            : this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming?.ondernemingen;

        if (ondernemingen && ondernemingen.length > 0
            && ondernemingen[0].ondernemingsvorm  // ← null-check toevoegen
            && ondernemingen[0].ondernemingsvorm !== Ondernemingsvorm.EENMANSZAAK) {
            this.heeftSamenwerkingsverband = ondernemingen[0].invullenOpNiveauSamenwerkingsverband ?? false;
        } else {
            this.heeftSamenwerkingsverband = false;
        }
    }

    createJaarrekeningBalans(omschrijving: string): JaarrekeningBalans {
        return {
            waardeOpening: undefined as unknown as number,
            waardeSlot: undefined as unknown as number,
            omschrijving: omschrijving,
            nominaleWaarde: undefined as unknown as number,
            aanschafWaarde: undefined as unknown as number,
            restWaarde: undefined as unknown as number,
            bodemwaarde: undefined as unknown as number,
            omzetbelastingDitBoekjaar: undefined as unknown as number,
            omzetbelastingVorigBoekjaar: undefined as unknown as number,
            omzetbelastingOudereBoekjaren: undefined as unknown as number,
            gebruikBinnenEigenOnderneming: undefined as unknown as boolean
        } as JaarrekeningBalans;
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe(); // ← partner subscription
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
        }
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe();
        }
        if (this.clientEntitySubscription) {
            this.clientEntitySubscription.unsubscribe();
        }
        if (this.heeftSamenwerkingsverbandSubscription) {
            this.heeftSamenwerkingsverbandSubscription.unsubscribe();
        }
    }

    handleUrlChange(newUrl: string) {
        if (!this.isSaving && this.hasUnsavedChanges()) {
            this.isSaving = true;
            this.dataService.postIncomeTaxEntity(this.clientId, false, this.incomeTaxEntity);
            this.isSaving = false;
        }
    }

    private hasUnsavedChanges(): boolean {
        return this.immaterieleVasteActivaGoodwllFg.dirty ||
            this.immaterieleVasteActivaOverigFg.dirty ||
            this.materieleVasteActivaGebouwenEigenFg.dirty ||
            this.materieleVasteActivaMachinesFg.dirty ||
            this.materieleVasteActivaOverigFg.dirty ||
            this.financieleVasteActivaFg.dirty ||
            this.vlottendeActivaVoorraadFg.dirty ||
            this.vlottendeActivaVoorraadOhwFg.dirty ||
            this.vlottendeActivaVorderingenDebiteurenFg.dirty ||
            this.vlottendeActivaVorderingenOmzetbelastingFg.dirty ||
            this.vlottendeActivaVorderingenOverigFg.dirty ||
            this.effectenFg.dirty ||
            this.liquideMiddelenFg.dirty ||
            this.totalFg.dirty;
    }


    saveForm(): void {
        if (!this.partnerBoolean) {
            this.incomeTaxEntity.aangifte = {
                ...this.incomeTaxEntity.aangifte,
                box1: {
                    ...this.incomeTaxEntity.aangifte?.box1,
                    winstUitOnderneming: {
                        ...this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming,
                        ondernemingen: [
                            {
                                ...this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming?.ondernemingen[0],
                                immaterieleVasteActiva: [this.immaterieleVasteActivaGoodwllFg.value, this.immaterieleVasteActivaOverigFg.value],
                                materieleVasteActiva: [this.materieleVasteActivaGebouwenEigenFg.value, this.materieleVasteActivaMachinesFg.value, this.materieleVasteActivaOverigFg.value],
                                financieleVasteActiva: [this.financieleVasteActivaFg.value],
                                vlottendeActivaVoorraad: [this.vlottendeActivaVoorraadFg.value, this.vlottendeActivaVoorraadOhwFg.value],
                                vlottendeActivaVorderingen: [this.vlottendeActivaVorderingenDebiteurenFg.value, this.vlottendeActivaVorderingenOmzetbelastingFg.value, this.vlottendeActivaVorderingenOverigFg.value],
                                effecten: [this.effectenFg.value],
                                liquideMiddelen: [this.liquideMiddelenFg.value]
                            }]
                    }
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
        } else {
            this.incomeTaxEntity.aangifte = {
                ...this.incomeTaxEntity.aangifte,
                partnerAangifte: {
                    ...this.incomeTaxEntity.aangifte?.partnerAangifte,
                    box1: {
                        ...this.incomeTaxEntity.aangifte?.partnerAangifte?.box1,
                        winstUitOnderneming: {
                            ...this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming,
                            ondernemingen: [
                                {
                                    ...this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen[0],
                                    immaterieleVasteActiva: [this.immaterieleVasteActivaGoodwllFg.value, this.immaterieleVasteActivaOverigFg.value],
                                    materieleVasteActiva: [this.materieleVasteActivaGebouwenEigenFg.value, this.materieleVasteActivaMachinesFg.value, this.materieleVasteActivaOverigFg.value],
                                    financieleVasteActiva: [this.financieleVasteActivaFg.value],
                                    vlottendeActivaVoorraad: [this.vlottendeActivaVoorraadFg.value, this.vlottendeActivaVoorraadOhwFg.value],
                                    vlottendeActivaVorderingen: [this.vlottendeActivaVorderingenDebiteurenFg.value, this.vlottendeActivaVorderingenOmzetbelastingFg.value, this.vlottendeActivaVorderingenOverigFg.value],
                                    effecten: [this.effectenFg.value],
                                    liquideMiddelen: [this.liquideMiddelenFg.value]
                                }]
                        }
                    }
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
        }
    }

    public heeftOndernemingen(): boolean {
        if (this.partnerBoolean) {
            return !!(this.incomeTaxEntity.aangifte &&
                this.incomeTaxEntity.aangifte?.partnerAangifte &&
                this.incomeTaxEntity.aangifte?.partnerAangifte.box1 &&
                this.incomeTaxEntity.aangifte?.partnerAangifte.box1.winstUitOnderneming &&
                this.incomeTaxEntity.aangifte?.partnerAangifte.box1.winstUitOnderneming.ondernemingen &&
                this.incomeTaxEntity.aangifte?.partnerAangifte.box1.winstUitOnderneming.ondernemingen.length > 0);
        } else {
            return !!(this.incomeTaxEntity.aangifte &&
                this.incomeTaxEntity.aangifte?.box1 &&
                this.incomeTaxEntity.aangifte?.box1.winstUitOnderneming &&
                this.incomeTaxEntity.aangifte?.box1.winstUitOnderneming.ondernemingen &&
                this.incomeTaxEntity.aangifte?.box1.winstUitOnderneming.ondernemingen.length > 0);
        }
    }

    private getRelevantAangifte(): Aangifte | undefined {
        return this.partnerBoolean
            ? this.incomeTaxEntity.aangifte?.partnerAangifte
            : this.incomeTaxEntity.aangifte;
    }

    private getOndernemingen(): Onderneming[] | undefined {
        const aangifte = this.getRelevantAangifte();
        return aangifte?.box1?.winstUitOnderneming?.ondernemingen;
    }

}
